import type { PostHog } from 'posthog-js';

import { isDaylight, isSpark, Product } from './productHelpers';

import { logError } from '@/utils/logError';
import { envSwitch } from '@/utils/environmentUtils';

type GetDistinctIdFn = (opts: { variables: { email: string } }) => Promise<{
  data?: { posthogDistinctIdWithEmail?: { distinctId?: string | null } | null } | null;
}>;

export function linkPostHogIdentity(
  getDistinctId: GetDistinctIdFn,
  posthog: PostHog | undefined,
  email: string,
  logPrefix = '[PostHog]',
): Promise<void> {
  return getDistinctId({ variables: { email } })
    .then((result) => {
      const distinctId = result?.data?.posthogDistinctIdWithEmail?.distinctId;
      if (distinctId) { posthog?.identify(distinctId, { email }); }
    })
    .catch((e) => { logError(logPrefix, 'PostHog identify failed', e); });
}

export enum PosthogProgram {
  SLEEPIO = 'sleepio',
  SPARK = 'spark_direct',
  DAYLIGHT = 'daylight',
  DAYLIGHT_PLATGEN = 'daylight_platgen',
}

export const SLEEPIO_PROGRAM = PosthogProgram.SLEEPIO;

export const SPARK_PROGRAM = PosthogProgram.SPARK;

export const DAYLIGHT_PROGRAM = PosthogProgram.DAYLIGHT;

export const postHogHost = 'https://us.i.posthog.com';

// All non-production US environments (dev, stage, pr, qa) use the same PostHog project
export const projectApiKey = envSwitch({
  local: '',
  dev: 'phc_8oCK6vDiV0qmfDsNW7YUQK9t3Vios1oEoz3gPPL893S', // US Non-prod
  stage: 'phc_8oCK6vDiV0qmfDsNW7YUQK9t3Vios1oEoz3gPPL893S', // US Non-prod
  pr: 'phc_8oCK6vDiV0qmfDsNW7YUQK9t3Vios1oEoz3gPPL893S', // US Non-prod
  qa: 'phc_8oCK6vDiV0qmfDsNW7YUQK9t3Vios1oEoz3gPPL893S', // US Non-prod
  prod: 'phc_8QW21BDgUVTJrtxo6cuV7vu8vMqp4020M9jIGoHCHWE', // Production
});

export const getProgram = (product: Product): PosthogProgram => {
  if (isSpark(product)) {
    return SPARK_PROGRAM;
  }
  if (isDaylight(product)) {
    return DAYLIGHT_PROGRAM;
  }
  return SLEEPIO_PROGRAM;
};

export const getPlatgenProgram = (product: Product): PosthogProgram => {
  if (isDaylight(product)) {
    return PosthogProgram.DAYLIGHT_PLATGEN;
  }
  return getProgram(product);
};
